import { RouterProvider } from "react-router-dom";

import { ActiveWorkspaceProvider } from "@/hooks/use-active-workspace";
import { AuthProvider } from "@/hooks/use-auth";
import { SidebarProvider } from "@/hooks/use-sidebar";
import { LocaleProvider } from "@/i18n";
import { router } from "@/router";

export default function App() {
  return (
    <LocaleProvider>
      <AuthProvider>
        <ActiveWorkspaceProvider>
          <SidebarProvider>
            <RouterProvider router={router} />
          </SidebarProvider>
        </ActiveWorkspaceProvider>
      </AuthProvider>
    </LocaleProvider>
  );
}
